import { take, put, call, all } from 'redux-saga/effects';
import moment from 'moment';

import log from 'yeself-client-common/utils/LogUtils';

import { MOMENT_DATE_FILTER_QUERY } from 'Console/constants/date';

import { FETCH_AUDIT } from './constants';
import { fetchAuditData, fetchAuditError } from './actions';
import { fetchAuditService } from './services';

function* fetchAudit() {
    while (true) {
        const { payload } = yield take(FETCH_AUDIT);
        const params = {
            dateFrom: moment(payload.dateFrom).format(MOMENT_DATE_FILTER_QUERY),
            dateTo: moment(payload.dateTo).format(MOMENT_DATE_FILTER_QUERY),
        };

        try {
            const res = yield call(fetchAuditService, params);
            yield put(fetchAuditData(JSON.parse(res.text).payload));
        } catch (err) {
            log.error(err);
            yield put(fetchAuditError());
        }
    }
}

export default function* auditSaga() {
    yield all([fetchAudit()]);
}
